import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserSettingsService } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/user-settings/services/user-settings.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import type { IDynamicRouteData } from '../../../../../dynamic-routes';

@Component({
  standalone: false,
  selector: 'suvo-bi-email-alerts-screen',
  templateUrl: './email-alerts-screen.component.html',
  styleUrls: ['./email-alerts-screen.component.scss'],
})
export class EmailAlertsScreenComponent implements OnInit {
  private readonly unsubscribe$ = new Subject<void>();

  alias: string;
  debugState: {
    alias?: string;
    dynamicRoute?: IDynamicRouteData;
    onboardingFromStorage?: unknown;
    userSettingsResponse?: unknown;
  } = {};

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly userSettings: UserSettingsService,
  ) {}

  private resolveAlias(data: IDynamicRouteData): string {
    return (
      data.filterGroup ||
      data.branch?.[0]?.variants?.[0]?.pathSegment ||
      data.branch?.[0]?.filterGroup ||
      ''
    );
  }

  private async routeDataChanged(data: IDynamicRouteData) {
    console.debug('[EmailAlertsScreen] route data changed', data);
    this.alias = this.resolveAlias(data);

    if (!this.alias) {
      console.warn('[EmailAlertsScreen] unable to resolve alias from route data', data);
      return;
    }

    this.debugState = {
      ...this.debugState,
      alias: this.alias,
      dynamicRoute: data,
    };

    const emailAlertsOnboardingRaw = localStorage.getItem('emailAlertsOnboarding');
    let emailAlertsOnboarding;
    if (emailAlertsOnboardingRaw) {
      emailAlertsOnboarding = JSON.parse(emailAlertsOnboardingRaw);
    } else {
      const userSettings = (await this.userSettings.get()) || {};
      console.debug('[EmailAlertsScreen] user settings response', userSettings);
      this.debugState = {
        ...this.debugState,
        userSettingsResponse: userSettings,
      };
      emailAlertsOnboarding = userSettings.passedEmailAlertsOnboarding;
    }

    if (
      emailAlertsOnboarding &&
      typeof emailAlertsOnboarding === 'object' &&
      'undefined' in emailAlertsOnboarding
    ) {
      delete emailAlertsOnboarding.undefined;
    }

    this.debugState = {
      ...this.debugState,
      onboardingFromStorage: emailAlertsOnboarding,
    };

    if (!emailAlertsOnboarding || (emailAlertsOnboarding && !emailAlertsOnboarding[this.alias])) {
      emailAlertsOnboarding = { ...(emailAlertsOnboarding || {}), [this.alias]: true };
      await this.userSettings.post({ passedEmailAlertsOnboarding: emailAlertsOnboarding });
      localStorage.setItem('emailAlertsOnboarding', JSON.stringify(emailAlertsOnboarding));
    }
  }

  ngOnInit() {
    this.activatedRoute.data.pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {
      console.debug('[EmailAlertsScreen] activated route data', data);
      this.routeDataChanged(data.dynamicRoute);
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
